<template>
  <section class="vr360-flex-column vr360-auth">
    <header class="vr360-wrap__inner vr360-auth-header">
      <p class="vr360-logo">
        <i class="vr360-icon bg-vr360-logo"></i>
      </p>
    </header>
    <main class="vr360-auth-main vr360-wrap__inner">
      <router-view />
    </main>
    <footer class="vr360-wrap__inner vr360-auth-footer">
      <div class="vr360-soc-block">
        <p class="vr360-head-h4 vr360-soc-block__title">Login via:</p>
        <ul class="vr360-soc-block__list">
          <li class="vr360-soc-block__list__item">
            <a class="vr360-link vr360-soc-block__link" 
               :href="`${domain}/api/v1/auth/social/facebook`">
              <i class="vr360-icon bg-facebook"></i>
            </a>
          </li>
          <!-- <li class="vr360-soc-block__list__item">
            <a class="vr360-link vr360-soc-block__link" href="#">
              <i class="vr360-icon bg-twitter"></i>
            </a>
          </li> -->
          <li class="vr360-soc-block__list__item">
            <a class="vr360-link vr360-soc-block__link"
               :href="`${domain}/api/v1/auth/social/google`">
              <i class="vr360-icon bg-google"></i>
            </a>
          </li>
        </ul>
      </div>
      <p class="vr360-auth-footer__link-block vr360-auth-footer__link-block--border">
        <span class="vr360-text-reg">New here?</span>
        <router-link :to="{ name: 'Register' }" class="vr360-head-h4 vr360-text-blue vr360-link" v-if="state === 'Login'">Sign up</router-link>
        <router-link :to="{ name: 'Login' }" class="vr360-head-h4 vr360-text-blue vr360-link" v-if="state === 'Register'">Login</router-link>
      </p>
    </footer>
  </section>
</template>

<script>
import setts from "@/config/url";

export default {
  name: "Auth",
  data() {
    return {
      state: null,
    };
  },
  created() {
    this.state = this.$route.name;
  },
  watch: {
    $route(to, from) {
      this.state = to.name;
    }
  },
  computed: {
    domain() {
      return setts.DOMAIN;
    }
  }
};
</script>

<style lang="scss">
</style>
